import { api } from '../../../api/axios'
import type { Atirador, AtiradorFilters } from '../types'

export interface ListResponse<T> {
  data: T[]
  meta: { total: number; page: number; limit: number; totalPages: number }
}

export const atiradorService = {
  list: (filters: AtiradorFilters = {}) =>
    api.get<ListResponse<Atirador>>('/atiradores', { params: filters }).then(r => r.data),

  getById: (id: number) =>
    api.get<{ data: Atirador }>(`/atiradores/${id}`).then(r => r.data.data),

  create: (data: Omit<Atirador, 'idatirador' | 'data_cadastro' | 'clube_nome'>) =>
    api.post<{ data: Atirador }>('/atiradores', data).then(r => r.data.data),

  update: (id: number, data: Partial<Omit<Atirador, 'idatirador' | 'data_cadastro' | 'clube_nome'>>) =>
    api.put<{ data: Atirador }>(`/atiradores/${id}`, data).then(r => r.data.data),

  delete: (id: number) =>
    api.delete(`/atiradores/${id}`),

  enviarConvite: (data: {
    idatiradores: number[]; idcampeonato: number; numero_etapa: number
    assunto: string; mensagem: string
  }) =>
    api.post<{ data: ResultadoConvite }>('/atiradores/enviar-convite', data).then(r => r.data.data),
  enviarConviteWhatsapp: (data: {
    idatiradores: number[]; idcampeonato: number; numero_etapa: number; mensagem: string
  }) =>
    api.post<{ data: EnvioWhatsapp }>('/atiradores/enviar-convite-whatsapp', data).then(r => r.data.data),
  statusConviteWhatsapp: (id: string) =>
    api.get<{ data: EnvioWhatsapp }>(`/atiradores/enviar-convite-whatsapp/${id}`).then(r => r.data.data),
  whatsappEstado: () =>
    api.get<{ data: { estado: EstadoWhatsapp } }>('/atiradores/whatsapp/estado').then(r => r.data.data.estado),
  whatsappQrcode: () =>
    api.post<{ data: { qrcode: string | null } }>('/atiradores/whatsapp/qrcode', {}).then(r => r.data.data.qrcode),
}

export interface ResultadoConvite {
  enviados: Array<{ idatirador: number; nome: string; email: string }>
  sem_email: Array<{ idatirador: number; nome: string }>
  falhas: Array<{ idatirador: number; nome: string; email: string; erro: string }>
}

export type EstadoWhatsapp = 'open' | 'connecting' | 'close' | 'inexistente'

export interface EnvioWhatsapp {
  id: string
  total: number
  processados: number
  concluido: boolean
  enviados: Array<{ idatirador: number; nome: string; telefone: string }>
  sem_telefone: Array<{ idatirador: number; nome: string }>
  falhas: Array<{ idatirador: number; nome: string; telefone: string; erro: string }>
}
